const extractPrice = (priceElement) => {
  // мэтчим содержимое последних скобок
  const priceMatch = priceElement.value.match(/\(([^()]*)\)$/);
  return priceMatch ? priceMatch[1] : '';
};

const changePrice = (priceElement, { convertedPrice }) => {
  const wholeElementText = priceElement.value;
  priceElement.value = wholeElementText.replace(
    /\([^()]*\)$/,
    `(${convertedPrice})`
  );
};

const matchType = (selector) => selector.tagName === 'INPUT';

export default { matchType, extractPrice, changePrice, name: 'input' };
